import { FileProps } from '@/common/types/common'
import { apiService } from './apiService'
import { fileEndpoints } from '@/api/apiEndpoint'

export const fileService = {
  async irFileUpload(
    companyId: number,
    data: File[]
  ): Promise<FileProps[] | null> {
    try {
      const formData = new FormData()
      data.forEach(file => {
        formData.append('files', file)
      })
      const response = await apiService.post<FileProps[]>(
        fileEndpoints.irFileUpload(companyId),
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      return response
    } catch (err: any) {
      console.error(err)
      return null
    }
  },
  async uploadFile(
    data: File[]
  ): Promise<FileProps[] | null> {
    try {
      const formData = new FormData() 
      data.forEach(file => {
        formData.append('files', file)
      })
      const response = await apiService.post<FileProps[]>(
        fileEndpoints.uploadFile(),
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      return response
    } catch (err: any) {
      console.error(err)
      return null
    }
  },
  async uploadFileImage(
    data: File[]
  ): Promise<FileProps[] | null> {
    try {
      const formData = new FormData() 
      data.forEach(file => {
        formData.append('files', file)
      })
      const response = await apiService.post<FileProps[]>(
        fileEndpoints.uploadFileImage(),
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      return response
    } catch (err: any) {
      console.error(err)
      return null
    }
  },
  async downloadFile(fileId: number, fileName?: string): Promise<void> {
    const response = await apiService.get<string>(fileEndpoints.getFile(fileId))
    const res = await fetch(response, { method: 'GET' })
    const blob = await res.blob()
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = fileName || `file_${fileId}`
    document.body.appendChild(link)
    link.click()
    link.remove()
  },
}
